export default {
    common: {
        email: 'E-mail',
        LoginBtn: 'Zaloguj się',
        SignUpBtn: 'Zarejestruj się',
        SubmitBtn: 'Wyślij',
        ExitBtn: 'Wyjście',
        LogoutBtn: 'Wyloguj się'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Sprawdź swoją skrzynkę e-mail, aby uzyskać kod weryfikacyjny.',
        VerificationCode: 'Kod weryfikacyjny'
    },
    header: {
        OrderHistory: 'Historia zamówień',
        MYACCOUNT: 'MOJE KONTO',
        WelcomeBack: 'Witaj ponownie'
    },
    detail: {
        TotalOrders: 'Zamówienia',
        TotalProducts: 'Produkty',
        WonderlandPoints: 'Punkty Wonderland',
        APMCredits: 'Kredyty APM',
        ExpireOn: 'Wygasa',
        NoAPMCredits: 'Brak kredytów APM',
        CreditsLoading: 'Ładowanie kredytów',
        Orders: 'Zamówienie',
        Online: 'Online',
        Boutique: 'Butik',
        Total: 'Razem',
        Delivered: 'Dostarczone',
        NoData: 'Brak danych',
        Status: 'Status',
        item: 'pozycja',
        items: 'pozycje'
    },
    panel: {},
    entry: {
        Client: 'Klient',
        OrderDate: 'Data zamówienia',
        DeliverDate: 'Data dostawy',
        Description: 'Opis',
        Total: 'Razem'
    },
    board: {
        Order: 'ZAMÓWIENIE',
        Date: 'DATA',
        Total: 'RAZEM'
    },
    order: {
        OrderID: 'ID zamówienia',
        PurchasePlace: 'Lokalizacja',
        PurchaseDate: 'Data zakupu',
        TotalPrice: 'Cena całkowita',
    },
    product: {
        Name: 'Nazwa',
        SKU: 'SKU',
        Size: 'Rozmiar',
        Quantity: 'Ilość',
        Price: 'Cena',
        WarrantyUntil: 'Gwarancja do',
    },
    ordersLayout: {
            pageTitleOrders: "Zamówienia",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "Strona główna",
            navProfile: "Profil",
            navOrders: "Zamówienia",
            navWonderland: "Wonderland",
            navWishlist: "Lista życzeń",
            navContactUs: "Kontakt",
            navExchangeReturn: "Wymiana i zwrot",
            footerExchangePolicy: "Polityka wymiany i zwrotu",
            footerShipping: "Dostawa",
            footerPrivacy: "Polityka prywatności",
            footerTerms: "Regulamin",
            footerRegion: "Francja",
            menuTrackOrder: "Śledź zamówienie",
            menuViewDetails: "Zobacz szczegóły",
            back: "Wstecz",
            orderNumberHeading: "Numer zamówienia {{id}}",
            itemsCount_one: "{{count}} produkt",
            itemsCount_other: "{{count}} produkty",
            emptyOrders: "Nie masz jeszcze żadnych zamówień.",
            loading: "Ładowanie",
            invoiceSoon: "Wkrótce",
            storeAddressPending: "Adres wkrótce",
            skuPrefix: "SKU",
            statusLabel: "Status",
            productNameFallback: "Produkt",
            tabOnline: "ONLINE",
            tabOffline: "OFFLINE",
            learnMore: "DOWIEDZ SIĘ WIĘCEJ",
            redeemInStore: "ZREALIZUJ W SKLEPIE",
            dateLabel: "Data",
            itemSingular: "Produkt",
            statusConfirmed: "Potwierdzono",
            purchaseDateLabel: "Data zakupu:",
            monthJan: "Sty",
            monthFeb: "Lut",
            monthMar: "Mar",
            monthApr: "Kwi",
            monthMay: "Maj",
            monthJun: "Cze",
            monthJul: "Lip",
            monthAug: "Sie",
            monthSep: "Wrz",
            monthOct: "Paź",
            monthNov: "Lis",
            monthDec: "Gru",
            storeLabel: "Butik",
            downloadInvoice: "Pobierz fakturę",
            warrantyExpires: "Gwarancja wygasa",
            sizeLabel: "Rozmiar",
            subtotalLabel: "Suma częściowa",
            totalLabel: "Razem",
            ecListTitle: "Twoje zamówienia",
            ecStatusInStore: "Status: zakup w butiku",
            ecOrderNumber: "Numer zamówienia: {{order_number}}",
            ecDateStore: "{{date}} · {{store_name}}",
            ecCountTotalOne: "{{count}} szt.: razem {{amount}}",
            ecCountTotalOther: "{{count}} szt.: razem {{amount}}",
            ecViewOrder: "Zobacz zamówienie >",
            ecViewOrderA11y: "Zobacz zamówienie {{order_number}}",
            ecBackToOrders: "Wróć do zamówień",
            ecInStoreDate: "Zakup w butiku – {{date}}",
            ecProductsOne: "Produkt",
            ecProductsOther: "Produkty",
            ecSku: "Nr ref. {{sku}}",
            ecQty: "Ilość: {{qty}}",
            ecWarrantyExpired: "Poza gwarancją",
            ecWarrantyActive: "Objęty gwarancją",
            ecSubtotalOne: "Suma częściowa – {{count}} szt.",
            ecSubtotalOther: "Suma częściowa – {{count}} szt.",
        },
}



// WEBPACK FOOTER //
// ./src/locales/pl/index.js